import theme from "../theme/theme";
import { CampaignStatus } from "../types/CampaignTypes";
import { IntegrationType, IntegrationColors } from "../types/CompanyTypes";

export const integrationColors: Record<IntegrationType, IntegrationColors> = {
  [IntegrationType.DV360]: {
    background: theme.palette.primary.light,
    text: theme.palette.primary.contrastText,
  },
  [IntegrationType.TABOOLA]: {
    background: theme.palette.secondary.light,
    text: theme.palette.secondary.contrastText,
  },
  [IntegrationType.OUTBRAIN]: {
    background: theme.palette.info.light,
    text: theme.palette.info.contrastText,
  },
  [IntegrationType.SPOTIFY]: {
    background: theme.palette.success.light,
    text: theme.palette.success.contrastText,
  },
  [IntegrationType.HIVESTACK]: {
    background: theme.palette.warning.light,
    text: theme.palette.warning.contrastText,
  },
  [IntegrationType.AMAZON]: {
    background: theme.palette.error.light,
    text: theme.palette.error.contrastText,
  },
  [IntegrationType.META]: {
    background: theme.palette.secondary.light,
    text: theme.palette.secondary.contrastText,
  },
  [IntegrationType.TIKTOK]: {
    background: theme.palette.neutral[600],
    text: theme.palette.neutral[100],
  },
  [IntegrationType.GOOGLE_ADS]: {
    background: theme.palette.primary.main,
    text: theme.palette.primary.contrastText,
  },
  [IntegrationType.REDDIT]: {
    background: theme.palette.warning.main,
    text: theme.palette.warning.contrastText,
  },
};

export const getIntegrationColors = (
  type: IntegrationType
): IntegrationColors => {
  return (
    integrationColors[type] || {
      background: theme.palette.grey[300],
      text: theme.palette.grey[900],
    }
  );
};

export const getCampaignColorByStatus = (status: CampaignStatus) => {
  switch (status) {
    case CampaignStatus.ACTIVE:
      return theme.palette.success.main;
    case CampaignStatus.PAUSED:
      return theme.palette.warning.main;
    case CampaignStatus.DEACTIVATED:
      return theme.palette.neutral[400];
    case CampaignStatus.ERROR:
      return theme.palette.error.main;
    default:
      return theme.palette.info.main;
  }
};
